import * as actionTypes from './actionTypes';

export const setTRestore = () => ({
    type: actionTypes.SET_TRESTORE,
});

// 重置選項
export const setTReset = () => ({
    type: actionTypes.SET_TRESET
});

export const setTNowListID = (payload: any) => ({
    type: actionTypes.SET_TNOWLISTID,
    payload,
});

export const setTNowListData = (payload: any) => ({
    type: actionTypes.SET_TNOWLISTDATA,
    payload,
});

export const setTDetailData = (payload: any) => ({
    type: actionTypes.SET_TDETAILDATA,
    payload,
});

export const setTTicketNum = (payload: any) => ({
    type: actionTypes.SET_TTICKECTNUM,
    payload,
});

export const setTTotalAmount = (payload: any) => ({
    type: actionTypes.SET_TTOTALAMOUNT,
    payload,
});

export const setSalePriceSpread = (payload: any) => ({
    type: actionTypes.SET_SALEPRICESPREAD,
    payload,
});

export const setShowCrossellTag = (payload: any) => ({
    type: actionTypes.SET_SHOWCROSSELL,
    payload,
});

export const setTTempCalendarData = (payload: any) => ({
    type: actionTypes.SET_TTEMPCALENDARDATA,
    payload,
});

export const setTPickCalendar = (payload: any) => ({
    type: actionTypes.SET_TPICKCALENDAR,
    payload,
});

export const setTIsDetailLoading = (payload: any) => ({
    type: actionTypes.SET_TISDETAILLOADING,
    payload,
});

export const setTDetailLoadingFail = (payload: any) => ({
    type: actionTypes.SET_TDETAILLOADINGFAIL,
    payload,
});

export const setTIsSessionLoading = (payload: any) => ({
    type: actionTypes.SET_TISSESSIONLOADING,
    payload,
});

export const setTSessionLoadingFail = (payload: any) => ({
    type: actionTypes.SET_TSESSIONLOADINGFAIL,
    payload,
});

export const setTCalendarErrorMsg = (payload: any) => ({
    type: actionTypes.SET_TCALENDARERRORMSG,
    payload,
});

export const setTSessionErrorMsg = (payload: any) => ({
    type: actionTypes.SET_TSESSIONERRORMSG,
    payload,
});

export const setTTicketErrorMsg = (payload: any) => ({
    type: actionTypes.SET_TTICKETERRORMSG,
    payload,
});

export const setTScollTo = (payload: any) => ({
    type: actionTypes.SET_TSCROLLTO,
    payload,
});

export const setTSubmitWatcher = (payload: any) => ({
    type: actionTypes.SET_TSUBMITWATCHER,
    payload,
});

export const setTIsSubmitSuccess = (payload: any) => ({
    type: actionTypes.SET_TISSUBMITSUCCESS,
    payload,
});

export const setTMInfoShow = (payload: any) => ({
    type: actionTypes.SET_TMINFOSHOW,
    payload,
});

export const setTSubmitErrMsg = (payload: any) => ({
    type: actionTypes.SET_TSUBMITERRMSG,
    payload,
});

export const setTFinalAbleDates = (payload: any) => ({
    type: actionTypes.SET_TFINALABLEDATES,
    payload,
});

// 自建
export const setTOpenNvbRslb = (payload: any) => ({
    type: actionTypes.SET_TOPENNVBRSLB,
    payload,
});

export const setTAllSessions = (payload: any) => ({
    type: actionTypes.SET_TALLSESSIONS,
    payload,
});

export const setTDisabledSessions = (payload: any) => ({
    type: actionTypes.SET_TDISABLEDSESSIONS,
    payload,
});

export const setTPickSession = (payload: any) => ({
    type: actionTypes.SET_TPICKSESSION,
    payload,
});

export const setTDisabledDateBySession = (payload: any) => ({
    type: actionTypes.SET_TDISABLEDDATEBYSESSION,
    payload,
});

export const setTMinDate = (payload: any) => ({
    type: actionTypes.SET_TMINDATE,
    payload,
});

export const setTNullDate = (payload: any) => ({
    type: actionTypes.SET_TNULLDATE,
    payload,
});

export const setTDisabledDate = (payload: any) => ({
    type: actionTypes.SET_TDISABLEDDATE,
    payload,
});

export const setTSoldoutDate = (payload: any) => ({
    type: actionTypes.SET_TSOLDOUTDATE,
    payload,
});

export const setTETItemData = (payload: any) => ({
    type: actionTypes.SET_TETITEMDATA,
    payload,
});

// GDS
/*
// 完全回到initstate
export const setTGRestore = () => ({
    type: actionTypes.SET_TGRESTORE,
});

// 重置選項，若有月曆回到預選第一天
export const setTGReset = () => ({
    type: actionTypes.SET_TGRESET,
});

export const setCalendar = (payload: any) => ({
    type: actionTypes.SET_TGCALENDAR,
    payload,
});

export const setTicketNum = (payload: any) => ({
    type: actionTypes.SET_TGTICKECTNUM,
    payload,
});

export const setSession = (payload: any) => ({
    type: actionTypes.SET_TGSESSION,
    payload,
});

export const setSessionPicked = (payload: any) => ({
    type: actionTypes.SET_TGSESSIONPICKED,
    payload,
});

export const setTotalAmount = (payload: any) => ({
    type: actionTypes.SET_TGTOTALAMOUNT,
    payload,
});

export const setGDetail = (payload: any) => ({
    type: actionTypes.SET_TGDETAIL,
    payload,
});

export const setGTempCalendarData = (payload: any) => ({
    type: actionTypes.SET_TGTEMPCALENDARDATA,
    payload,
});

export const setIsTGDSDetailLoading = (payload: any) => ({
    type: actionTypes.SET_ISTGDSDETAILLOADING,
    payload,
});

export const setTGDSDetailFetchFail = (payload: any) => ({
    type: actionTypes.SET_TGDDETAILFETCHFAIL,
    payload,
});

export const setIsTGDSSessionLoading = (payload: any) => ({
    type: actionTypes.SET_ISTGDSSESSIONLOADING,
    payload,
});

export const setTGDSSessionFetchFail = (payload: any) => ({
    type: actionTypes.SET_TGDSSESSIONFETCHFAIL,
    payload,
});

export const setTGNowList = (payload: any) => ({
    type: actionTypes.SET_TGNOWLIST,
    payload,
});

export const setTGNowListData = (payload: any) => ({
    type: actionTypes.SET_TGNOWLISTDATA,
    payload,
});

export const setTGMInfoShow = (payload: any) => ({
    type: actionTypes.SET_TGMINFOSHOW,
    payload,
});

export const setTGCalenderErr = (payload: any) => ({
    type: actionTypes.SET_TGCALENDARERR,
    payload,
});

export const setTGSessionErr = (payload: any) => ({
    type: actionTypes.SET_TGSESSIONERR,
    payload,
});

export const setTGTicketErr = (payload: any) => ({
    type: actionTypes.SET_TGTICKETErr,
    payload,
});

export const setScrollTo = (payload: any) => ({
    type: actionTypes.SET_TGSCROLLTO,
    payload,
});

export const setSubmitWatcher = (payload: any) => ({
    type: actionTypes.SET_TGSUBMITWATCHER,
    payload,
});

export const setIsSubmitSuccess = (payload: any) => ({
    type: actionTypes.SET_ISTGSUBMITSUCCESS,
    payload,
});

export const setTGFinalAbleDates = (payload: any) => ({
    type: actionTypes.SET_TGFINALABLEDATES,
    payload,
});

export const setTGSubmitErrMsg = (payload: any) => ({
    type: actionTypes.SET_TGSUBMITERRMSG,
    payload,
});
*/